import { BcmNetworkPrinter } from '@shared/models/network-printer';
import { BcmUserLastUsedReceiptPrinterSettings } from '@shared/models/bcm-settings-user';

export function resolveSelectedReceiptPrinter(
    receiptPrinters: BcmNetworkPrinter[],
    lastUsedSettings: BcmUserLastUsedReceiptPrinterSettings | undefined,
): BcmNetworkPrinter | null {
    if (lastUsedSettings !== undefined) {
        if (lastUsedSettings.printerId != null) {
            return receiptPrinters.find(p => p.id === lastUsedSettings.printerId) ?? null;
        }

        return null;
    }

    return receiptPrinters[0] ?? null;
}
